export default "/assets/426dc7a9ea03c3df.png"